const ErrorCodes = {
  HTTP_CLIENT_ERROR: 'HTTP_CLIENT_ERROR',
};

export { ErrorCodes };
